export default "__VITE_PUBLIC_ASSET__97db6fdf__"